import * as React from "react";
import DeviceAssignmentCreateForm from "../components/DeviceAssignmentCreateForm";

export default function DeviceAssignmentCreatePage() {
  return <DeviceAssignmentCreateForm />;
}